import { render, staticRenderFns } from "./IconSvgCertificat.vue?vue&type=template&id=333bda18&scoped=true&"
import script from "./IconSvgCertificat.vue?vue&type=script&lang=js&"
export * from "./IconSvgCertificat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333bda18",
  null
  
)

export default component.exports